import React, {useEffect, useState} from 'react';
import FooterWave from '../footer/footer-wave';
import {Column, Row} from '../layout';
import './styles.scss';
import colors from '../../util/colors';
import {bindActionCreators, compose} from 'redux';
import {connect} from 'react-redux';
import {setUser, setIsAuthenticated} from '../../store/actions';
import {strings, functionalitiesAliasMap} from '../../util/strings';
import {createGUID} from '../../util/utility';
import appStoreBtn from '../../assets/Apple.svg';
import googlePlayBtn from '../../assets/Android.svg';
import {ITenant} from '../../App';
import AuthorizedImage from '../images';
import {useHistory} from 'react-router';
import {Constants} from '../../oauth/helpers/constants';

interface AppFooterProps {
  isAuthenticated: any;
  labels: typeof strings.pt.footer;
  busFuncMap: any;
  selectedBu: any;
  loadingInfo: boolean;
  buStyles: any;
  accessToken: any;
  tenant: ITenant;
  updateImages: number;
}

function AppFooter(props: AppFooterProps) {
  const {tenant} = props;

  const history = useHistory();
  const appStoreUrl =
    'https://apps.apple.com/pt/app/myadvancecare/id1236671968';
  const googlePlayUrl =
    'https://play.google.com/store/apps/details?id=com.advancecare.particulares&hl=pt_PT&gl=US';
  const isServiaPortal = tenant?.country === 'RS';

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [legalInfo, setLegalInfo] = useState([]);
  const [displayHelp, setDisplayHelp] = useState(true);
  const [displaySettings, setDisplaySettings] = useState(true);

  const [applyHoverEffect, setApplyHoverEffect] = useState(true);

  const authenticatedElements =
    window.location.href.includes('/atualizar-termos') ||
    window.location.href.includes('/tratamento-dados') ||
    window.location.href.includes('/informacao-seguro') ||
    window.location.href.includes('/politica-marketing');

  const appFooterContainerStyle = {marginTop: 0, marginBottom: '-10px'};

  function getWindowWidth() {
    const {innerWidth: width} = window;
    setWindowWidth(width);
  }

  useEffect(() => {
    window.addEventListener('resize', getWindowWidth);
    setApplyHoverEffect(false);
    return () => window.removeEventListener('resize', getWindowWidth);
  }, []);

  useEffect(() => {
    props.busFuncMap[props.selectedBu]?.forEach((func: any) => {
      var legalList: any = [];
      if (
        func.featureTemplateAlias ===
          functionalitiesAliasMap.legalInformation &&
        func.isVisible
      ) {
        func.labels?.forEach((info: any) => {
          if (info.type === 'LEGALINFO') {
            legalList.push(info);
          }
        });
        setLegalInfo(
          legalList.filter((info: any) => info.url !== '' && info.url !== null),
        );
      }
    });
    const commonQuestions = props.busFuncMap[props.selectedBu]?.find(
      (e: any) =>
        e.featureTemplateAlias === functionalitiesAliasMap.faq && !e.isVisible,
    );
    const talkWithUs = props.busFuncMap[props.selectedBu]?.find(
      (el: any) =>
        el.featureTemplateAlias === functionalitiesAliasMap.talkWithUs &&
        !el.isVisible,
    );
    const quickGuide = props.busFuncMap[props.selectedBu]?.find(
      (element: any) =>
        element.featureTemplateAlias === functionalitiesAliasMap.quickGuide &&
        !element.isVisible,
    );
    const myProfile = props.busFuncMap[props.selectedBu]?.find(
      (element: any) =>
        element.featureTemplateAlias === functionalitiesAliasMap.myProfile &&
        !element.isVisible,
    );
    const permissions = props.busFuncMap[props.selectedBu]?.find(
      (element: any) =>
        element.featureTemplateAlias === functionalitiesAliasMap.permissions &&
        !element.isVisible,
    );
    if (myProfile && permissions) {
      setDisplaySettings(true);
    } else {
      setDisplaySettings(false);
    }
    if (commonQuestions && talkWithUs && quickGuide) {
      setDisplayHelp(false);
    } else {
      setDisplayHelp(true);
    }
  }, [props.selectedBu, props.busFuncMap]);

  const hoverElement = (index: any) => {
    setTimeout(() => {
      const element: HTMLCollection =
        document.getElementsByClassName('app-footer-anchor');
      var footerElement: HTMLElement = element[index] as HTMLElement;
      if (footerElement && !applyHoverEffect)
        footerElement.style.color = props.buStyles.primaryColor;
    }, 100);
  };

  const hoverElementNoIndex = (func: any) => {
    setTimeout(() => {
      const elements: HTMLCollection =
        document.getElementsByClassName('app-footer-anchor');
      var elementArray: any[] = Array.from(elements);
      var result = elementArray.find((el: any) => {
        let className: string = el.className;
        if (className.includes(func)) {
          return el;
        }
      });
      var footerElement: HTMLElement = result as HTMLElement;
      if (footerElement && !applyHoverEffect)
        footerElement.style.color = props.buStyles.primaryColor;
    }, 100);
  };

  const hoverOut = (index: any) => {
    setTimeout(() => {
      const element: HTMLCollection =
        document.getElementsByClassName('app-footer-anchor');
      var footerElement: HTMLElement = element[index] as HTMLElement;
      if (footerElement) footerElement.style.color = colors.black;
    }, 100);
  };

  const hoverOutNoIndex = (func: any) => {
    setTimeout(() => {
      const elements: HTMLCollection =
        document.getElementsByClassName('app-footer-anchor');
      var elementArray: any[] = Array.from(elements);
      var result = elementArray.find((el: any) => {
        let className: string = el.className;
        if (className.includes(func)) {
          return el;
        }
      });
      var footerElement: HTMLElement = result as HTMLElement;
      if (footerElement) footerElement.style.color = colors.black;
    }, 100);
  };

  const calculateFooterHeight = (): string => {
    if (!props.isAuthenticated) {
      return 'auto';
    }

    if (windowWidth <= 768) {
      return authenticatedElements ? '30vh' : '500px';
    }

    return 'auto';
  };

  return (
    <>
      {props.accessToken && (
        <div
          className="app-footer-wrapper"
          style={{
            height: calculateFooterHeight(),
          }}>
          {!window.location.href.includes('/atualizar-termos') &&
            !window.location.href.includes('/tratamento-dados') &&
            !window.location.href.includes('/informacao-seguro') &&
            !window.location.href.includes('/politica-marketing') && (
              <Row
                style={!!!props.isAuthenticated ? appFooterContainerStyle : {}}
                id="amyadv-footer"
                className="app-footer-container">
                {props.isAuthenticated ? (
                  !props.loadingInfo && (
                    <>
                      {props.labels?.appDownloadVisible === '1' && (
                        <Column className="app-footer-footercolumn mobile-block">
                          <strong className="app-footer-footercolumn-title app-footer-title-big">
                            {props.labels?.dowload_app}
                          </strong>
                          &nbsp;
                          <br />
                          <a target="_blank" href={appStoreUrl}>
                            <img
                              className="app-footer-button"
                              src={appStoreBtn}
                            />
                          </a>
                          <a target="_blank" href={googlePlayUrl}>
                            <img
                              className="app-footer-button"
                              src={googlePlayBtn}
                            />
                          </a>
                        </Column>
                      )}
                      {/** This info was moved to MyProfile in PT-UAT but is displayed here in RS */}
                      {legalInfo.length !== 0 && isServiaPortal && (
                        <Column className="app-footer-footercolumn">
                          <strong className="app-footer-footercolumn-title">
                            {props.labels?.legalInformation}
                          </strong>
                          &nbsp;
                          <br />
                          {legalInfo?.map((info: any, index: any) => {
                            return (
                              <a
                                key={createGUID()}
                                onMouseEnter={() => hoverElement(index)}
                                onMouseOut={() => hoverOut(index)}
                                className="app-footer-anchor"
                                href={info.url}
                                target="_blank">
                                {info.text}
                              </a>
                            );
                          })}
                        </Column>
                      )}
                      {displayHelp && (
                        <Column className="app-footer-footercolumn">
                          <strong className="app-footer-footercolumn-title">
                            {props.labels?.help}
                          </strong>
                          &nbsp;
                          <br />
                          {props.busFuncMap
                            ? props.busFuncMap[props.selectedBu]?.map(
                                (func: any, index: any) => {
                                  if (
                                    func?.isVisible &&
                                    func?.featureTemplateAlias ===
                                      functionalitiesAliasMap.talkWithUs
                                  ) {
                                    return (
                                      <a
                                        key={createGUID()}
                                        onMouseEnter={() =>
                                          hoverElementNoIndex('talkToUs')
                                        }
                                        onMouseOut={() =>
                                          hoverOutNoIndex('talkToUs')
                                        }
                                        className="app-footer-anchor talkToUs"
                                        onClick={() => {
                                          history.push('/fale-connosco');
                                        }}>
                                        {props.labels?.talkToUs}
                                      </a>
                                    );
                                  }
                                },
                              )
                            : null}
                          {props.busFuncMap
                            ? props.busFuncMap[props.selectedBu]?.map(
                                (func: any) => {
                                  if (
                                    func?.isVisible &&
                                    functionalitiesAliasMap.faq ===
                                      func.featureTemplateAlias
                                  ) {
                                    return (
                                      <a
                                        key={createGUID()}
                                        onMouseEnter={() =>
                                          hoverElementNoIndex('commonQuestions')
                                        }
                                        onMouseOut={() =>
                                          hoverOutNoIndex('commonQuestions')
                                        }
                                        className="app-footer-anchor commonQuestions"
                                        onClick={() => {
                                          history.push('/perguntas-frequentes');
                                        }}>
                                        {props.labels?.commonQuestions}
                                      </a>
                                    );
                                  }
                                },
                              )
                            : null}
                          {props.busFuncMap
                            ? props.busFuncMap[props.selectedBu]?.map(
                                (func: any) => {
                                  if (
                                    func?.isVisible &&
                                    func?.featureTemplateAlias ===
                                      functionalitiesAliasMap.legalInformation &&
                                    legalInfo.length !== 0
                                  ) {
                                    return (
                                      <a
                                        key={createGUID()}
                                        onMouseEnter={() =>
                                          hoverElementNoIndex(
                                            'legalInformation',
                                          )
                                        }
                                        onMouseOut={() =>
                                          hoverOutNoIndex('legalInformation')
                                        }
                                        className="app-footer-anchor"
                                        onClick={() => {
                                          history.push('/informacoes-legais');
                                        }}>
                                        {props.labels?.legalInformation}
                                      </a>
                                    );
                                  }
                                },
                              )
                            : null}
                          {/* {props.busFuncMap
                            ? props.busFuncMap[props.selectedBu]?.map(
                              (func: any, index: any) => {
                                if (
                                  func?.isVisible &&
                                  func?.featureTemplateAlias ===
                                  functionalitiesAliasMap.quickGuide
                                ) {
                                  return (
                                    <a
                                      key={createGUID()}
                                      onMouseEnter={() =>
                                        hoverElementNoIndex('quickGuide')
                                      }
                                      onMouseOut={() =>
                                        hoverOutNoIndex('quickGuide')
                                      }
                                      className="app-footer-anchor quickGuide"
                                      href="#">
                                      {props.labels?.quickGuide}
                                    </a>
                                  );
                                }
                              }
                            )
                            : null}
                          {props.busFuncMap
                            ? props.busFuncMap[props.selectedBu]?.map(
                              (func: any, index: any) => {
                                if (
                                  func?.isVisible &&
                                  func?.featureTemplateAlias ===
                                  functionalitiesAliasMap.clientGuide
                                ) {
                                  return (
                                    <>
                                      {clientGuideURL && (
                                        <a
                                          key={createGUID()}
                                          onMouseEnter={() =>
                                            hoverElementNoIndex('clientGuide')
                                          }
                                          onMouseOut={() =>
                                            hoverOutNoIndex('clientGuide')
                                          }
                                          className="app-footer-anchor clientGuide"
                                          target="_blank"
                                          href={clientGuideURL}>
                                          {props.labels?.clientGuide}
                                        </a>
                                      )}
                                      {!clientGuideURL && (
                                        <a
                                          key={createGUID()}
                                          onMouseEnter={() =>
                                            hoverElementNoIndex('clientGuide')
                                          }
                                          onMouseOut={() =>
                                            hoverOutNoIndex('clientGuide')
                                          }
                                          className="app-footer-anchor clientGuide"
                                          target="_blank">
                                          {props.labels?.clientGuide}
                                        </a>
                                      )}
                                    </>
                                  );
                                }
                              }
                            )
                            : null} */}
                        </Column>
                      )}
                      {/** This info was moved to MyProfile in PT-UAT but is displayed here in RS */}
                      {!displaySettings && isServiaPortal && (
                        <Column className="app-footer-footercolumn">
                          <strong className="app-footer-footercolumn-title">
                            {props.labels?.settings}
                          </strong>
                          &nbsp;
                          <br />
                          {props.busFuncMap
                            ? props.busFuncMap[props.selectedBu]?.map(
                                (func: any, index: any) => {
                                  if (
                                    func?.isVisible &&
                                    func?.featureTemplateAlias ===
                                      functionalitiesAliasMap.myProfile
                                  ) {
                                    return (
                                      <a
                                        key={createGUID()}
                                        onMouseEnter={() =>
                                          hoverElementNoIndex('myProfile')
                                        }
                                        onMouseOut={() =>
                                          hoverOutNoIndex('myProfile')
                                        }
                                        onClick={() => {
                                          history.push('/perfil');
                                        }}
                                        className="app-footer-anchor myProfile">
                                        {props.labels?.myProfile}
                                      </a>
                                    );
                                  }
                                },
                              )
                            : null}
                          <br />
                          {props.busFuncMap
                            ? props.busFuncMap[props.selectedBu]?.map(
                                (func: any, index: any) => {
                                  if (
                                    func?.isVisible &&
                                    func?.featureTemplateAlias ===
                                      functionalitiesAliasMap.permissions
                                  ) {
                                    return (
                                      <a
                                        key={createGUID()}
                                        onMouseEnter={() =>
                                          hoverElementNoIndex('permissions')
                                        }
                                        onMouseOut={() =>
                                          hoverOutNoIndex('permissions')
                                        }
                                        className="app-footer-anchor app-footer-permissions permissions"
                                        style={{marginTop: '-12px'}}
                                        onClick={() => {
                                          history.push('/permissoes');
                                        }}>
                                        {props.labels?.permissions}
                                      </a>
                                    );
                                  }
                                },
                              )
                            : null}
                        </Column>
                      )}
                      {!displayHelp && (
                        <Column className="app-footer-footercolumn app-footer-no-help-column"></Column>
                      )}
                      <Column className="app-footer-footercolum-logo">
                        <div className="app-footer-footerlogo">
                          {props.updateImages >= 1 &&
                            Constants.appDefaultTenantAlias !== 'RS' && (
                              <AuthorizedImage
                                requiresAuthorization={false}
                                key={props.updateImages}
                                width="65%"
                                source={`${
                                  process.env
                                    .REACT_APP_BASE_BACKOFFICE_IMAGES_URL_PUBLIC
                                }${
                                  props.tenant?.footerImage ||
                                  props.buStyles.logo
                                }`}
                                alt="ADVLogo"
                              />
                            )}
                        </div>
                        <div style={{color: colors.lightGrey}}>
                          <span className="app-footer-footercolum-copyright">
                            {props.labels?.copyright}
                          </span>
                          <br />
                          <small>
                            {props.labels?.version}
                            {process.env.REACT_APP_BUILD_NBR}
                          </small>
                        </div>
                      </Column>
                    </>
                  )
                ) : (
                  <div></div>
                )}
              </Row>
            )}
          {authenticatedElements ? (
            <FooterWave color={colors.blue}></FooterWave>
          ) : (
            <FooterWave color={props.buStyles.primaryColor}></FooterWave>
          )}
          <div
            className="app-footer-mobilefooter"
            style={
              authenticatedElements
                ? {backgroundColor: colors.blue}
                : {backgroundColor: props.buStyles.primaryColor}
            }>
            <Column className="app-footer-mobilefooter-column">
              {windowWidth <= 768 && props.updateImages >= 1 && (
                <AuthorizedImage
                  requiresAuthorization={false}
                  key={props.updateImages}
                  width="60%"
                  source={`${
                    process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL_PUBLIC
                  }${props.tenant.footerImage || props.buStyles.logo}`}
                  alt="advancecare"
                />
              )}
              <div style={{color: colors.white}}>
                <span className="app-footer-footercolum-copyright">
                  {props.labels?.copyright}
                </span>
                <br />
                <small>
                  {`${props.labels?.version} ${process.env.REACT_APP_BUILD_NBR}`}
                </small>
              </div>
            </Column>
          </div>
        </div>
      )}
    </>
  );
}

const mapStateToProps = ({
  isAuthenticated,
  strings,
  busFuncMap,
  selectedBu,
  loadingInfo,
  globalStyles,
  accessToken,
  tenant,
}: any) => ({
  isAuthenticated: isAuthenticated.value,
  loadingInfo: loadingInfo.value,
  labels: strings.value.pt.footer,
  busFuncMap: busFuncMap.value,
  selectedBu: selectedBu.value.buId,
  buStyles: globalStyles.value,
  accessToken: accessToken.value,
  tenant: tenant.value,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators({setUser, setIsAuthenticated}, dispatch);

export default compose(connect(mapStateToProps, mapDispatchToProps)(AppFooter));
